import * as Location from '../Data/Location'
import {Dictionary} from './Dictionary'
import * as RouteDefinition from './RouteDefinition'
import {parsePath} from './RouteDefinition'

export interface M<T> {
    readonly route: T,
    readonly queryParameters: Dictionary<string>
}

export function fromLocation<T>(
    routeDefinitions: RouteDefinition.M<T>[],
    location: Location.M,
): M<T | null> {
    return {
        route: parsePath(routeDefinitions, location.path),
        queryParameters: location.parameters,
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/RoutedLocation.ts